module.exports = __webpack_public_path__ + "3a6feb47cf7ca949345efe3b55561f14.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/potlood.mp3
// module id = 36
// module chunks = 0